import {
  getRightSpacingValue,
  getSpacingValue,
  getTopSpacingValue,
  TSpace,
} from '~ui/styleGuide/spaces'

type TOptions = {
  padding: TSpace
}

/**
 * calculates the padding values used by Modal components
 * based on the provided key
 * used by ModalSettingsProvider but can be used as a helper in a custom modal as well
 */
export const useModalPadding = ({ padding }: TOptions) => {
  const paddingValue = getSpacingValue(padding)
  const paddingVerticalValue = getTopSpacingValue(padding)
  const paddingHorizontalValue = getRightSpacingValue(padding)

  // split the padding values in half when we want to join header & body (or body & footer)
  const paddingVerticalHalfValue = `calc(${paddingVerticalValue} / 2)`
  const paddingHorizontalHalfValue = `calc(${paddingHorizontalValue} / 2)`

  return {
    paddingValue,
    paddingVerticalValue,
    paddingHorizontalValue,
    paddingVerticalHalfValue,
    paddingHorizontalHalfValue,
  }
}
